<div class="flex flex-col h-full w-full overflow-hidden">
  <div class="flex-none backdrop-blur-sm py-2 z-10 transition-all">
    <div
      class="flex flex-row items-center justify-center gap-8 transform origin-top"
    >
      <div class="flex flex-col items-center">
        <span
          class="text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-1"
          >Anteriore</span
        >
        <div class="body-container h-100 w-auto aspect-375/833">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 375.42 832.97"
            class="h-full w-full drop-shadow-sm"
            aria-label="Mappa del corpo, vista anteriore"
          >
            <g>
              @for (part of antBodyParts; track trackById($index, part)) {
                <path
                  [attr.d]="part.d"
                  [ngStyle]="getStyle(part.bodyPartId)"
                  (mouseenter)="handleMouseEnter(part.bodyPartId)"
                  (mouseleave)="handleMouseLeave()"
                  (click)="handlePartClick(part.bodyPartId)"
                  (keydown.enter)="
                    handlePartClick(part.bodyPartId); $event.preventDefault()
                  "
                  (keydown.space)="
                    handlePartClick(part.bodyPartId); $event.preventDefault()
                  "
                  role="button"
                  [attr.aria-label]="'Seleziona ' + part.name"
                  [matTooltip]="part.name"
                  tabindex="0"
                  class="outline-none"
                />
              }
            </g>
          </svg>
        </div>
      </div>

      <div class="flex flex-col items-center">
        <span
          class="text-[10px] font-bold uppercase tracking-widest text-gray-400 mb-1"
          >Posteriore</span
        >
        <div class="body-container h-100 w-auto aspect-375/833">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 375.42 832.97"
            class="h-full w-full drop-shadow-sm"
            aria-label="Mappa del corpo, vista posteriore"
          >
            <g>
              @for (part of postBodyParts; track trackById($index, part)) {
                <path
                  [attr.d]="part.d"
                  [ngStyle]="getStyle(part.bodyPartId)"
                  (mouseenter)="handleMouseEnter(part.bodyPartId)"
                  (mouseleave)="handleMouseLeave()"
                  (click)="handlePartClick(part.bodyPartId)"
                  (keydown.enter)="
                    handlePartClick(part.bodyPartId); $event.preventDefault()
                  "
                  (keydown.space)="
                    handlePartClick(part.bodyPartId); $event.preventDefault()
                  "
                  role="button"
                  [attr.aria-label]="'Seleziona ' + part.name"
                  [matTooltip]="part.name"
                  tabindex="0"
                  class="outline-none"
                />
              }
            </g>
          </svg>
        </div>
      </div>
    </div>
  </div>

  <div
    class="flex-1 overflow-y-auto bg-white p-4 custom-scrollbar scroll-smooth"
  >
    @if (notes().length === 0) {
      <div
        class="flex flex-col items-center justify-center h-40 animate-in fade-in duration-500"
      >
        <mat-icon class="text-5xl w-auto! h-auto! mb-2 opacity-50 scale-110"
          >touch_app</mat-icon
        >
        <p class="text-sm font-medium">
          Seleziona un'area del corpo per iniziare
        </p>
      </div>
    }
    <mat-accordion displayMode="flat" multi="false">
      @for (note of notes(); track note.bodyPartId) {
        <mat-expansion-panel
          class=" rounded-lg mb-3 overflow-hidden transition-all duration-300"
          [class.border-primary]="expandedPartId() === note.bodyPartId"
          [class.ring-1]="expandedPartId() === note.bodyPartId"
          [class.ring-primary]="expandedPartId() === note.bodyPartId"
          [expanded]="expandedPartId() === note.bodyPartId"
          (opened)="setActiveNote(note.bodyPartId)"
        >
          <mat-expansion-panel-header class="h-12.5! px-4!">
            <mat-panel-title
              class="flex! items-center! gap-3! grow! overflow-hidden! mr-2!"
            >
              <div
                class="w-2.5 h-2.5 shrink-0! rounded-full shadow-sm transition-colors duration-200"
                [class.bg-error]="isNoteInvalid(note)"
                [class.bg-primary]="!isNoteInvalid(note)"
              ></div>

              <span
                class="truncate font-bold text-sm"
                [class.text-error]="isNoteInvalid(note)"
                [class.text-gray-700]="!isNoteInvalid(note)"
              >
                {{ getPartName(note.bodyPartId) }}
              </span>

              @if (isNoteInvalid(note)) {
                <mat-icon
                  class="text-error! w-4! h-4! text-[16px]! leading-none ml-1 animate-pulse shrink-0!"
                  matTooltip="Campi obbligatori mancanti"
                >
                  error_outline
                </mat-icon>
              }
            </mat-panel-title>

            <mat-panel-description
              class="grow-0! shrink-0! basis-auto! m-0! flex! justify-end! items-center!"
            >
              <button
                mat-icon-button
                type="button"
                color="warn"
                (click)="removeNote(note.bodyPartId, $event)"
                matTooltip="Rimuovi nota"
              >
                <mat-icon class="scale-90 material-icons-outlined"
                  >delete</mat-icon
                >
              </button>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div class="flex flex-col gap-4 pt-4 pb-2 px-1">
            @if (expandedPartId() === note.bodyPartId) {
              <siat-input-field
                [formGroup]="formGroup"
                controlName="subject"
                placeholder="Inserisci oggetto nota"
                label="Oggetto nota"
              ></siat-input-field>

              <siat-textarea-field
                [formGroup]="formGroup"
                controlName="content"
                placeholder="Inserisci nota"
                label="Nota"
              ></siat-textarea-field>
            }
          </div>
        </mat-expansion-panel>
      }
    </mat-accordion>
    <!--   <mat-accordion displayMode="flat" multi="false">
      @for (note of notes(); track note.bodyPartId) {
        <mat-expansion-panel
          class="border border-gray-200 rounded-lg mb-3 overflow-hidden transition-all duration-300"
          [class.border-primary]="expandedPartId() === note.bodyPartId"
          [class.ring-1]="expandedPartId() === note.bodyPartId"
          [class.ring-primary]="expandedPartId() === note.bodyPartId"
          [expanded]="expandedPartId() === note.bodyPartId"
          (opened)="setActiveNote(note.bodyPartId)"
        >
          <mat-expansion-panel-header class="bg-gray-50 h-[50px]">
            <mat-panel-title
              class="flex items-center gap-3 text-sm font-bold grow min-w-0 mr-2"
            >
              <div
                class="w-2.5 h-2.5 rounded-full shadow-sm transition-colors duration-200"
                [class.bg-error]="isNoteInvalid(note)"
                [class.bg-primary]="!isNoteInvalid(note)"
              ></div>

              <span
                [class.text-error]="isNoteInvalid(note)"
                [class.text-gray-700]="!isNoteInvalid(note)"
              >
                {{ getPartName(note.bodyPartId) }}
              </span>

              @if (isNoteInvalid(note)) {
                <mat-icon
                  class="text-error w-4! h-4! text-[16px] leading-none ml-1 animate-pulse"
                  matTooltip="Campi obbligatori mancanti"
                >
                  error_outline
                </mat-icon>
              }
            </mat-panel-title>

            <mat-panel-description
              class="flex justify-end items-center grow-0 shrink-0 m-0"
            >
              <button
                mat-icon-button
                color="warn"
                (click)="removeNote(note.bodyPartId, $event)"
                matTooltip="Rimuovi nota"
              >
                <mat-icon class="scale-90 material-icons-outlined"
                  >delete</mat-icon
                >
              </button>
            </mat-panel-description>
          </mat-expansion-panel-header>

          <div class="flex flex-col gap-4 pt-4 pb-2 px-1">
            @if (expandedPartId() === note.bodyPartId) {
              <siat-input-field
                [formGroup]="formGroup"
                controlName="subject"
                placeholder="Inserisci oggetto nota"
                label="Oggetto nota"
              ></siat-input-field>

              <siat-textarea-field
                [formGroup]="formGroup"
                controlName="content"
                placeholder="Inserisci nota"
                label="Nota"
              ></siat-textarea-field>
            }
          </div>
        </mat-expansion-panel>
      }
    </mat-accordion> -->
  </div>
</div>
